






import Vue from 'vue'
export default Vue.extend({
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
  provide() {
    return this.$attrs
  },
})
